import { makeUnitsRepository } from 'shared/infra/repositories';

import FetchUnitByIdUseCase from './implementations/FetchUnitByIdUseCase';

let instance: FetchUnitByIdUseCase | null = null;

export default function makeFetchUnitByIdUseCase() {
  if (!instance) {
    const unitsRepository = makeUnitsRepository();

    instance = new FetchUnitByIdUseCase(unitsRepository);
  }

  return instance;
}
